import { EMAIL_REGEX } from 'common/constants'

export const onSubmit = (action, baseData) => e => {
  e.stopPropagation()
  e.preventDefault()
  const entries = new FormData(e.target).entries()
  const data = { ...baseData }

  for (const [name, value] of entries) {
    data[name] = value
  }

  action(data)
}

export const isValidEmail = email => EMAIL_REGEX.test(email)

// onChange is not fired in React 15.6+ without native setter
// with this we can listen for onChange on parent elements
// https://stackoverflow.com/a/46012210
const nativeInputSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set

export const nativeSetValue = (input, value) => {
  nativeInputSetter.call(input, value)
  input.dispatchEvent(new Event('input', { bubbles: true }))
}

export const updateField = function({ name, value, initialValue, changed = 0 }, callback) {
  this.setState(
    state => ({
      fields: {
        ...(state.fields || {}),
        [name]: { changed, name, value, initialValue },
      },
      changed: (state.changed || 0) - ((state.fields?.[name] || {}).changed || 0) + changed,
    }),
    callback
  )
}

export const hasChanged = ({ value, initialValue }) => value !== initialValue

export const onChange = function({ target: el }, callback) {
  const { name, value, type, checked, dataset } = el
  const checkbox = type == 'checkbox'

  const initial = this.state.fields?.[name]?.initialValue || dataset.initial
  const initialValue = initial || (checkbox ? el.hasAttribute('checked') : el.getAttribute('value'))
  const changed = (this.hasChanged || hasChanged)({ value: checkbox ? checked : value, initialValue, name });

  (this.updateField || updateField.bind(this))({ name, value, initialValue, changed }, callback)
}
